var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrossZ = function SvgCrossZ(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44253 4.9999L10.2142 1.22821L9.27142 0.2854L5.49973 4.05709L1.72894 0.286307L0.786133 1.22912L4.55692 4.9999L0.786133 8.77068L1.72894 9.71349L5.49973 5.94271L9.27142 9.7144L10.2142 8.77159L6.44253 4.9999Z",
    fill: "#727281"
  })));
};
export default SvgCrossZ;